import React, { useState } from 'react';

const AddProcessoModal = ({ isOpen, onClose, onSave, columnId }) => {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!title.trim()) {
      alert("O título é obrigatório.");
      return;
    }
    
    const processoData = {
      title: title.trim(),
      description: description.trim() || '',
    };

    onSave(columnId, processoData);
    setTitle('');
    setDescription('');
    onClose();
  };

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-70 z-50 flex justify-center items-center p-4" 
      onClick={onClose}
    >
      <div 
        className="max-w-md w-full glass-effect rounded-2xl p-8 border border-white border-opacity-20" 
        onClick={e => e.stopPropagation()}
      >
        <h2 className="heading-font text-2xl font-bold text-yellow-400 mb-6">
          Criar Novo Processo
        </h2>

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="process-title" className="block text-sm font-medium text-yellow-400 mb-1">
              Título do Processo *
            </label>
            <input
              id="process-title"
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="w-full px-4 py-2 bg-slate-800 border border-gray-600 rounded-md text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-gold"
              placeholder="Digite o título do processo"
              autoFocus
            />
          </div>

          <div className="mb-6">
            <label htmlFor="process-description" className="block text-sm font-medium text-yellow-400 mb-1">
              Descrição (opcional)
            </label>
            <textarea
              id="process-description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              rows={3}
              className="w-full px-4 py-2 bg-slate-800 border border-gray-600 rounded-md text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-gold"
              placeholder="Descrição do processo..."
            />
          </div>

          <div className="flex justify-end gap-3">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 bg-slate-700 text-yellow-400 rounded-md hover:bg-slate-600 transition-colors"
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="px-4 py-2 gold-gradient text-dark-navy font-semibold rounded-md hover:opacity-90 transition-opacity"
            >
              Criar Processo
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddProcessoModal;